import React from 'react';

export const Loader = (props) => {
    if (props.show) {
        return (
            <img id="fixed-Loader" src="./loader_big.svg" />
        );
    }
    return ("");
};

